var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 41,
    viewBox: "0 0 29 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 10.5C8.5 4.97716 12.9772 0.5 18.5 0.5C24.0228 0.5 28.5 4.97716 28.5 10.5V26.5C28.5 34.232 22.232 40.5 14.5 40.5C6.76802 40.5 0.5 34.232 0.5 26.5V14.5C0.5 13.3954 1.39544 12.5 2.5 12.5C3.60456 12.5 4.5 13.3954 4.5 14.5V26.5C4.5 32.0228 8.97716 36.5 14.5 36.5C20.0228 36.5 24.5 32.0228 24.5 26.5V10.5C24.5 7.1863 21.8138 4.5 18.5 4.5C15.1862 4.5 12.5 7.1863 12.5 10.5V26.5C12.5 27.6046 13.3954 28.5 14.5 28.5C15.6046 28.5 16.5 27.6046 16.5 26.5V14.5C16.5 13.3954 17.3954 12.5 18.5 12.5C19.6046 12.5 20.5 13.3954 20.5 14.5V26.5C20.5 29.8138 17.8138 32.5 14.5 32.5C11.1862 32.5 8.5 29.8138 8.5 26.5V10.5Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/icon-attach.3e27e61c8194c02068c372638c5ef406.svg";
export { ForwardRef as ReactComponent };